import React from "react";
import styled from "styled-components";
import Navbar from "../Navbar/Navbar";
import fipayFonts from "../../theme/index";

interface AboutUsHeroProps {}

const textContent = [
  {
    TextHeader: "About Us",
    MidFirstText: `Fipay is a digital payment Lorem ipsum dolor sit amet, consectetur
    adipiscing elit. Donec tempus libero nulla, nec dignissim nisi
    semper ac. Pellentesque auctor neque nec urna fringilla rhoncus.
    In hac habitasse platea dictumst.`,
    MidSecondText: `Vivamus vestibulum tortor ac leo maximus, vitae tincidunt diam
    molestie. Aenean eu leo quam. Pellentesque lorem leo, tempus at
    semper nec, Pellentesque auctor neque nec urna fringilla rhoncus.
    In hac habitasse platea dictumst.`,
  },
];

const AboutUsHero: React.FC<AboutUsHeroProps> = () => {
  return (
    <Container>
      <Navbar />
      <AboutUsHeroContainer>
        <AboutUsContent>
          <AboutUsTitle>{textContent[0].TextHeader}</AboutUsTitle>
          <AboutUsText>
            <FirstParagraph>{textContent[0].MidFirstText}</FirstParagraph>
            <SecondParagraph>{textContent[0].MidSecondText}</SecondParagraph>
          </AboutUsText>
        </AboutUsContent>
      </AboutUsHeroContainer>
    </Container>
  );
};

const Container = styled.div`
  background-image: url("/assets/icons/LandingPage.jpg");
  display: flex;
  align-items: center;
  background-size: cover;
  flex-direction: column;
`;

const AboutUsHeroContainer = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const AboutUsTitle = styled.h1`
  font-family: GT Walsheim Pro;
  font-size: 60px;
  font-weight: 700;
  line-height: 78px;
  letter-spacing: 0.5px;
  text-align: center;
  margin-bottom: 0px;
  color: #09005b;
  @media screen and (min-width: 0px) and (max-width: 766px) {
    font-size: 30px;
    line-height: 34.35px;
  }
  ${fipayFonts.fipayFonts.heading1};
`;

const FirstParagraph = styled.p`
  margin-bottom: 2rem;
  margin-left: 7rem;
  margin-right: 8rem;
  color: #5e5e5e;

  @media screen and (min-width: 0px) and (max-width: 766px) {
    margin-left: 0.8rem;
    margin-right: 0.8rem;
  }
`;

const SecondParagraph = styled.p`
  margin-left: 7rem;
  margin-right: 8rem;
  color: #5e5e5e;

  padding-bottom: 5rem;
  @media screen and (min-width: 0px) and (max-width: 766px) {
    margin-left: 0.8rem;
    margin-right: 0.8rem;
    padding-bottom: 0.8rem;
  }
`;

const AboutUsText = styled.p`
  text-align: center;
  ${fipayFonts.fipayFonts.body1};
`;

const AboutUsContent = styled.div`
  padding: 4rem;

  @media screen and (min-width: 0px) and (max-width: 766px) {
    padding: 1rem;
  }
`;

export default AboutUsHero;
